export default __webpack_public_path__ + "media/images/iui/thumb-4761a0bd440c0d8663d70bcca78e358a.png";